// Runtime configuration + environment detection.
//
// "Discord mode": we run inside the Activity iframe (Discord injects ?frame_id=...).
// "Mock mode": a plain browser tab (npm run dev) — DiscordSDKMock + the in-process mock
// backend stand in for Discord and hub-core so the whole ceremony is exercised offline.
//
// API base is `/api` in BOTH modes: in Discord, patchUrlMappings rewrites `/api/*` through
// the activity proxy to the real backend (the portal URL mapping strips `/api` and forwards
// the remainder, so `/api/arcade/config` lands on the backend's `/arcade/config`); in dev,
// the Vite mock plugin serves `/api/arcade/*` directly.

// Read defensively so this module also imports cleanly under Node (tests / SSR), where
// `window` and Vite's `import.meta.env` may be absent.
const ENV = ((import.meta as unknown as { env?: Record<string, string> }).env ?? {}) as Record<
  string,
  string | undefined
>;
const SEARCH = typeof window !== 'undefined' ? window.location.search : '';
const params = new URLSearchParams(SEARCH);

export const IS_DISCORD = params.has('frame_id');

export const DISCORD_CLIENT_ID: string = ENV.VITE_DISCORD_CLIENT_ID ?? 'mock-client-id';

// The backend's public host, registered in the Developer Portal URL mappings and passed to
// patchUrlMappings as the proxy target. Unused in mock mode.
export const ARCADE_TARGET: string = ENV.VITE_ARCADE_TARGET ?? '';

export const API_PREFIX = '/api';
export const API_BASE = `${API_PREFIX}/arcade`;

export const GAME_ID = 'wheel';

// OAuth scopes: identify (uid), guilds (read-only server membership — the backend's guild
// gate needs it, since verification forces Public Bot ON), applications.commands (Activity
// launch). No voice/message scopes — least privilege.
export const OAUTH_SCOPES: string[] = ['identify', 'guilds', 'applications.commands'];
